import { faCreditCardAlt } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';
import { Text16 } from 'atoms/typography';

const CreditCardIcon = styled(Text16)`
  border-radius: var(--half-unit);
  border: 1px solid var(--c-neutral-1000);
  background-color: var(--c-neutral-1000);
  padding: var(--half-unit) var(--intermediate-unit);
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(5 * var(--unit));
  color: var(--c-neutral-300);
`;

const Row = styled(Horizontal).attrs({ gap: 1.5 })``;

export const NewCreditCard = ({
  label = (
    <FormattedMessage
      id="NewPaymentBox.methods.addCreditCard"
      defaultMessage="Credit / Debit card"
    />
  ),
}: {
  label?: ReactNode;
}) => {
  return (
    <Row>
      <CreditCardIcon>
        <FontAwesomeIcon size="lg" icon={faCreditCardAlt} />
      </CreditCardIcon>
      <Text16 color="var(--c-neutral-1000)">{label}</Text16>
    </Row>
  );
};
export default NewCreditCard;
